'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.agentTypingMessageReceived = undefined;

var _pubnubMessageGetters = require('conversations-schema/pubnub-message/operators/pubnubMessageGetters');

var _commonMessageFormatGetters = require('conversations-schema/common-message-format/operators/commonMessageFormatGetters');

var _typingStateConstants = require('../constants/typingStateConstants');

var _addTypingTimeoutIdForAgentInThread = require('./addTypingTimeoutIdForAgentInThread');

var _dismissAgentTypingIndicator = require('./dismissAgentTypingIndicator');

var _clearExistingAgentTypingTimeout = require('./clearExistingAgentTypingTimeout');

var agentTypingMessageReceived = exports.agentTypingMessageReceived = function agentTypingMessageReceived(message) {
  return function (dispatch) {
    var threadId = (0, _pubnubMessageGetters.getThreadId)(message);
    var senderId = (0, _commonMessageFormatGetters.getSenderId)(message);

    dispatch((0, _clearExistingAgentTypingTimeout.clearExistingAgentTypingTimeout)(message));

    var timeoutId = setTimeout(function () {
      dispatch((0, _dismissAgentTypingIndicator.dismissAgentTypingIndicator)(message));
    }, _typingStateConstants.TYPING_INDICATOR_TIMEOUT_MS);

    dispatch((0, _addTypingTimeoutIdForAgentInThread.addTypingTimeoutIdForAgentInThread)(threadId, senderId, timeoutId));
  };
};


//////////////////
// WEBPACK FOOTER
// ./js/typing-indicators/actions/agentTypingMessageReceived.js
// module id = 419
// module chunks = 2 3